<form class="tabbed-dialog-layout" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="shrink-0 px-5 py-6">
    <span class="font-semibold text-xl">
      <span>{{ form.controls.clientName.value }}:</span>
      <p>{{ form.controls.taskType.value }} {{ form.controls.spanLabel.value }}</p>
    </span>
  </div>
  <div class="tabbed-dialog-body">
    <div class="flex flex-row items-center justify-between w-full">
      <div class="flex flex-col mr-2">
        <label for="status">Status</label>
        <app-form-activity-states-selector
          [selectableStates]="form.controls.selectableStates.value"
          formControlName="state"
          inputId="status"
          [errors]="form.controls.state.errors"></app-form-activity-states-selector>
      </div>
      <div class="flex flex-col mr-2">
        <label class="truncate" for="datestatus">Datum vid statusändring</label>
        <app-calendar
          appendTo="body"
          inputId="datestatus"
          formControlName="statusChangeDate"
          [invalid]="form.controls.statusChangeDate.invalid"
          [title]="form.controls.statusChangeDate.errors?.statusChangeDate?.message ?? ''"></app-calendar>
      </div>
      <div class="flex flex-col mr-2">
        <label class="truncate" for="users">Utförande handläggare</label>
        <app-form-user-selector
          width="w-48"
          formControlName="users"
          inputId="users"
          [breakpoint]="12"
          [isInvalid]="form.controls.users.errors?.message"
          [isMultiSelect]="true"
          [title]="form.controls.users.errors?.message ?? ''"></app-form-user-selector>
      </div>
      <div class="flex flex-col">
        <label for="datedeadline">Deadline</label>
        <app-calendar
          appendTo="body"
          inputId="datedeadline"
          formControlName="deadline"
          [invalid]="form.controls.deadline.invalid"
          [title]="form.controls.deadline.errors?.deadline?.message ?? ''"></app-calendar>
      </div>
    </div>

    <bl-frontend-textarea
      text="Om tjänsten ({{ form.controls.taskType.value }})"
      formControlName="taskComment"
      [maxLength]="2000"
      [rows]="3"
      class="block mt-5"></bl-frontend-textarea>

    <bl-frontend-textarea
      text="Kommentar"
      formControlName="comment"
      [maxLength]="2000"
      [rows]="5"
      class="block mt-5"></bl-frontend-textarea>

    <p class="!mt-5">Statushistorik</p>
    <app-table
      scrollHeight="180px"
      [columns]="columns"
      [data]="form.controls.stateChangeEvents.value"
      [searchField]="false"
      [columnSelector]="false"
      [paginator]="false">
    </app-table>
  </div>
  <div class="tabbed-dialog-actions flex justify-between items-end p-4 bg-bl-grey-100">
    <bl-frontend-button
      [leadingIcon]="{name: 'cog', size: 'lg'}"
      (onclick)="openTaskDialog()"
      title="Inställningar tjänsten"
      variant="tonal"></bl-frontend-button>
    <div class="flex items-center gap-3">
      <bl-frontend-button variant="secondary" (onclick)="close(null)" text="Stäng"></bl-frontend-button>
      <bl-frontend-button type="submit" [disabled]="form.invalid" text="Spara"></bl-frontend-button>
    </div>
  </div>
</form>
